export const CURRENT_LANGUAGE = 'CURRENT_LANGUAGE'
export const SEARCH_KEYWORD = 'SEARCH_KEYWORD'
export const RATING = 'RATING'
export const USER_DATA = 'USER_DATA'
export const SEARCH_VALUES = 'SEARCH_VALUES'
export const USER_DETAILS = 'USER_DETAILS'
export const PUBLICATION_SEARCH = 'PUBLICATION_SEARCH'
export const PUBLICATION_SEARCK_KEYWORD = 'PUBLICATION_SEARCK_KEYWORD'
export const PROPOSAL_ID = 'PROPOSAL_ID'
